import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { QuestionnaireService } from '../services/questionnaire.service';
import { LeadService } from "../services/lead.service";
import { TermsOfUseComponent } from "../terms-of-use/terms-of-use.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
	selector: 'app-summarize-page',
	templateUrl: './summarize-page.component.html',
	styleUrls: ['./summarize-page.component.scss']
})
export class SummarizePageComponent implements OnInit {
	user;
	errorMessage: string;
	userDetailsStep = this.questionnaireService.getStep("user-details");
	userCycleStep = this.questionnaireService.getStep("cycle-details");
	advisors = this.questionnaireService.getStep("advisors");
	//propertyDetailsStep = this.questionnaireService.getStep("property-details");
	//loanDetailsStep = this.questionnaireService.getStep("cycle-details");
	//financingSourcesStep = this.questionnaireService.getStep("financing-sources");
	//propertyValueOtherOptions = this.questionnaireService.getQuestion(this.propertyDetailsStep, "2").answer.fields[0].answerValue;
	//propertyValueSelfContruction = this.questionnaireService.getQuestion(this.propertyDetailsStep, "3").answer.fields[0].answerValue +
	//this.questionnaireService.getQuestion(this.propertyDetailsStep, "3").answer.fields[1].answerValue;
	//ifMehirLeMishtakerProject = this.questionnaireService.getQuestion(this.loanDetailsStep, "6").selectedAnswer[0] === "YES";
	//propertyValueMishtakenValue = this.questionnaireService.getQuestion(this.loanDetailsStep, "7").answer.fields[1].answerValue;
	cycleType = this.questionnaireService.getCycleType();
	isAdvisor = this.questionnaireService.getIsAdvisor();
	currentStep;
	summarizePage: FormGroup;
	submitted = false;
	isloading: boolean = false;
	isActive: boolean = true;
	

	modalRef;
	constructor(
		private router: Router,
		private fb: FormBuilder,
		private questionnaireService: QuestionnaireService,
		private leadService: LeadService,
		private modalService: NgbModal
	) { }

	ngOnInit() {
		this.errorMessage = "";
		window.scrollTo(0, 0);
		this.createForm();
		this.setValidators();
		this.user = {
			firstName: (this.isAdvisor)? 
			this.questionnaireService.getQuestion(this.advisors, "1").answer.fields[0].answerValue || "חסר"
			:this.questionnaireService.getQuestion(this.userDetailsStep, "1").answer.fields[0].answerValue || "חסר",
			propertyValue: this.questionnaireService.getQuestion(this.userCycleStep, "8").answer.fields[0].answerValue || 0,
			mortgageAmount: this.questionnaireService.getQuestion(this.userCycleStep, "5").answer.fields[0].answerValue || 0,
			monthlyRefundAmount: this.questionnaireService.getQuestion(this.userCycleStep, "2").answer.fields[0].answerValue || 0,
			cyclePurpose: this.questionnaireService.getQuestion(this.userCycleStep, "1").answersOptions[this.questionnaireService.getQuestion(this.userCycleStep, "1").selectedAnswer[0]].answerText,
			cycleAmount: this.questionnaireService.getQuestion(this.userCycleStep, "2").answer.fields[0].answerValue || 0,
			internalAreCycleAllMorygage: (this.questionnaireService.getQuestion(this.userCycleStep, "9").selectedAnswer[0] === 'NO')? 'מיחזור חלקי' : 'מיחזור מלא',
		};
	}

	onSubmit({ value, valid }: { value: any, valid: boolean }) {
		if(this.questionnaireService.openTermsOfUse ===false){
			if (valid) {
				let currentQuestion = this.questionnaireService.getQuestion(this.currentStep, "1");
				let textArea= this.summarizePage.controls['textArea'].value.replace(/\n/ig, ' ');
				this.questionnaireService.saveData(currentQuestion, [textArea]);
				currentQuestion.hasAnswer = true;

				if(!this.isAdvisor){
					let currentQuestion2 = this.questionnaireService.getQuestion(this.currentStep, "2");
					this.questionnaireService.saveData(currentQuestion2, [this.questionnaireService.getQuestion(this.currentStep, "2").selectedAnswer]);
					currentQuestion2.hasAnswer = true;
				}
				
				this.modalRef = this.modalService.open(TermsOfUseComponent, { size: 'lg' });
				this.modalRef.result.then((result) => {
					this.isloading = true;
					this.submitted = true;
					this.leadService.submitMashForm().subscribe(
						data => {
							console.log("send lead succeed");
							this.errorMessage = "";
							this.router.navigate(['end']);
							this.isloading = false;
						},
						error => {
							this.errorMessage = "שירות זה אנו זמין ברגע זה. נא לנסות מאוחר יותר";
							console.log("send lead failed");
							this.isloading = false;
						}
					)
				},error=>{console.log("close")});

				this.modalRef.componentInstance.submitForm = true;
			}
		}
	}

	createForm() {
		this.currentStep = this.questionnaireService.getStep("summarize");
		this.questionnaireService.getQuestion(this.currentStep, "2").selectedAnswer = 'YES';
		this.summarizePage = this.fb.group({
			textArea: this.questionnaireService.getQuestion(this.currentStep, "1").answer.fields[0].answerValue,
			marketingCB: this.questionnaireService.getQuestion(this.currentStep, "2")
		});
	}

	setValidators() {
		this.summarizePage.controls['textArea'].setValidators([Validators.pattern("^[0-9A-Za-zא-ת\ \n]*$"), Validators.maxLength(252)]);
		this.submitted = false;
	}

	cbChange() {
		this.isActive = !this.isActive;

		if(this.isActive) {
			this.questionnaireService.getQuestion(this.currentStep, "2").selectedAnswer = 'YES';
		} else {
			this.questionnaireService.getQuestion(this.currentStep, "2").selectedAnswer = 'NO';
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/summarize-page/summarize-page.component.ts